import React from 'react';
import A, { AnchorProps } from '@sls-react/components/Links/A';

type Props = AnchorProps & {
  page?: 'item';
  itemId?: string | number;
};

const SwapsInboxLink: React.FC<Props> = ({
  children,
  itemId,
  page,
  ...props
}) => (
  <A
    href={page === 'item' ? `/swaps/item/${itemId}` : '/swaps/all'}
    {...props}
    rel="nofollow noindex"
  >
    {children}
  </A>
);

export default SwapsInboxLink;
